import PositionsEmptyState from './PositionsEmptyState';

export default {
  ReactComponent: PositionsEmptyState,
};
